import {answerQuestion} from "content/facts";

export type AskSource = "model" | "facts";

export type AskResult = {
  answer: string;
  source: AskSource;
};

/**
 * Prefer the optional server-side model when it is deployed and keyed.
 * Always fall back to the local facts matcher so the desktop Terminal
 * works on `yarn start` and on deploys without a model key.
 */
export async function askNick(question: string): Promise<AskResult> {
  const local = answerQuestion(question);

  try {
    const response = await fetch("/api/ask", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({question}),
    });
    if (!response.ok) {
      return {answer: local, source: "facts"};
    }
    const data: unknown = await response.json();
    if (!data || typeof data !== "object") {
      return {answer: local, source: "facts"};
    }
    const answer = (data as {answer?: unknown}).answer;
    const source = (data as {source?: unknown}).source;
    if (typeof answer === "string" && answer.trim()) {
      return {
        answer: answer.trim(),
        source: source === "model" ? "model" : "facts",
      };
    }
  } catch {
    // Local matcher is the product; the function is optional.
  }

  return {answer: local, source: "facts"};
}
